import React from 'react';
import './NotFound.css';

const NotFound = () => {
    return (
        <div>
            <h1>404 Not Found the page</h1>
        </div>
    );
};

export default NotFound;